export const maxLimitPagination = 10;
